import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import JSConfetti from 'js-confetti'
import { api, authHeaders } from '../../services/api'
import { Button } from '../../components/Form'
import { FiArrowRight } from 'react-icons/fi'

const jsConfetti = new JSConfetti()

export default function () {
	const { id } = useParams()

	const history = useHistory()

	const [isLoading, setIsLoading] = useState(true)
	const [contratacaoOk, setContratacaoOk] = useState(null)

	const { data: plano } = useQuery({
		queryKey: ['obter-dados-modulo-gratis'],
		queryFn: async () => {
			const response = await api.get(`plano/${id}`)

			return response
		}
	})
	
	async function handleContratar() {
		try {
			await api.post(`contratar/gratis/${id}`, {}, authHeaders())

			setContratacaoOk(true)

			localStorage.removeItem('sigas:carrinho')

			jsConfetti.addConfetti()
		} catch(e) {
			setContratacaoOk(false)
		} finally {
			setIsLoading(false)
		}
	}

	useEffect(() => {
		handleContratar()

		jsConfetti.addConfetti()
	}, [])

	return (
		<div className="min-h-[80vh] flex items-center p-8 md:p-24 justify-center">
			{isLoading || !plano ? (
				<div className="text-slate-800">
					Aguarde, validando seu acesso...
				</div>
			) : contratacaoOk ? (
				<div className="flex flex-col gap-10 items-center">
					<div className="font-bold text-xl rounded-md p-4 text-center w-fit text-slate-700">
						Seu acesso ao {plano.modulo.descricao} - {plano.descricao} GRATUITO está liberado!
					</div>

					<Button onClick={() => { history.push('/dashboard/prontuario') }}>
						Ir para o {plano.modulo.descricao}
						<FiArrowRight size={16} />
					</Button>
				</div>
			) : (
				<div className="bg-red-400 font-bold text-xl w-fit rounded-md p-4 text-center">
					Houve um erro ao liberar seu acesso ao {plano.modulo.descricao} - {plano.descricao} GRATUITO.
				</div>
			)}
		</div>
	)
}
